<template>
<body class="layout-row">
  <div class="flex">
    <div class="w-xl w-auto-sm mx-auto py-5">
      <div class=" d-flex flex-column h-100 pb-0 pt-3">
        <a href="#">  
       <!--   <img src="dist/img/logo_big.png" class="img img-responsive" />  -->
        <img src="dist/img/AEsexylogo.png" class="img img-responsive logocenter" />
        </a>
        <!-- / brand -->
      </div>
      <div class="card">
        <div id="content-body">
          <div class="p-3 p-md-5">
            <h5>Login to Your Account</h5>
           
            <form @submit.prevent="signin" method="post" class="" role="form" >
              <div class="form-group">
                <label>User ID</label>
                <input  v-model="credential.email"  @keyup.enter="signin" type="text" class="form-control" placeholder="Enter email">
              </div>
              <div class="form-group">
                <label>Password</label>
                <input v-model="credential.password"  @keyup.enter="signin" type="password" class="form-control" placeholder="Password">
              </div>
             
              <button type="submit" class="btn btn-primary mb-4">Sign in</button>
            </form>
          </div>
        </div>
      </div>
      <div class="text-center text-muted">&copy; Copyright AE Sexy</div>
    </div>
  </div>
</body>





</template>


<script>
import { LOGIN,PLAY, FETCH_TASKS } from '@/store/mutation-types';
import { isMobile } from 'mobile-device-detect';


export default {
  name: 'Play',
  components: {
   
  },

  data () {
    return {
      credential: {
        email: '',
        password: '',
        mob : isMobile
        
      },
      mobstat : isMobile
    }
  },

  methods: {
    signin () {
      this.$http.post('sexymm/login', this.credential)
      .then(({ data }) => {
          this.$store.commit(PLAY, data.data)
          this.$store.commit(LOGIN, data.data)
         
          window.location.replace('/#/pageplay');
          
        }, ({ data }) => {
        //  data && alert(data.message)
          this.$bvToast.toast("Invalid User Id or password", {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            });
        })
    }
  }
}
</script>